import React from "react"
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import SplashScreen from './components/SplashScreen'
import { AuthProvider } from './context/AuthContext'
import { ToastProvider } from './context/ToastContext'
import { AnnouncementProvider } from './context/AnnouncementContext'
import { WebSocketProvider } from './context/WebSocketContext'
import { useAuth } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import AgreementModal from './components/AgreementModal'
import Rules from "./Rules/Rules"
import HowToPlay from "./Rules/HowToPlay"
import Navbar from "./navigation/Navbar"
import Login from './pages/Login'
import Register from './pages/Register'
import Lobby from './pages/Lobby'
import GameSetup from './pages/GameSetup'
import GamePlay from './pages/GamePlay'
import GlobalLookup from './pages/GlobalLookup'
import TopTenGames from './pages/TopTenGames'
import Profile from './pages/Profile'
import CreateAgreement from './pages/CreateAgreement'
import JoinGame from './pages/JoinGame'

function RootRedirect() {
    const { isAuthenticated } = useAuth()
    return <Navigate to={isAuthenticated ? '/lobby' : '/login'} replace />
}

export default function App() {
    const [showSplash, setShowSplash] = React.useState(true)

    return (
        <>
        {showSplash && <SplashScreen onDone={() => setShowSplash(false)} />}
        <AuthProvider>
            <ToastProvider>
                <AnnouncementProvider>
                <WebSocketProvider>
                    <Router>
                        <div className="w-full max-w-[1000px] mx-auto min-h-screen bg-bankroll-navy shadow-2xl rounded-lg overflow-hidden">
                            <AgreementModal />
                            <Navbar />
                            <Routes>
                                <Route path="/login"  element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/lobby" element={
                                    <ProtectedRoute><Lobby /></ProtectedRoute>
                                } />
                                <Route path="/game/:gameId/setup" element={
                                    <ProtectedRoute><GameSetup /></ProtectedRoute>
                                } />
                                <Route path="/game/:gameId" element={
                                    <ProtectedRoute><GamePlay /></ProtectedRoute>
                                } />
                                <Route path="/global-lookup" element={
                                    <ProtectedRoute><GlobalLookup /></ProtectedRoute>
                                } />
                                <Route path="/top-ten" element={
                                    <ProtectedRoute><TopTenGames /></ProtectedRoute>
                                } />
                                <Route path="/profile" element={
                                    <ProtectedRoute><Profile /></ProtectedRoute>
                                } />
                                <Route path="/agreements/create" element={
                                    <ProtectedRoute><CreateAgreement /></ProtectedRoute>
                                } />
                                <Route path="/join/:code" element={
                                    <ProtectedRoute><JoinGame /></ProtectedRoute>
                                } />
                                <Route path="/" element={<RootRedirect />} />
                                <Route path="/rules"  element={<Rules />} />
                                <Route path="/play"   element={<HowToPlay />} />
                            </Routes>
                        </div>
                    </Router>
                </WebSocketProvider>
                </AnnouncementProvider>
            </ToastProvider>
        </AuthProvider>
        </>
    )
}
